<template>
  <div class="selectLinePopup">
    <!-- 选线框 -->
    <van-overlay :show="showOverlay" z-index="999" class="selectLineOverlay">
      <div class="selectionLineBox">
        <div class="titleBox">选择线路</div>
        <div class="lineArea">
          <div
            class="lineBox"
            @click.stop="changeLine(item)"
            v-for="(item, index) in apiUrls"
            :key="item"
          >
            <div class="selected" v-if="item == currentApi">
              <div class="select"></div>
            </div>
            <div class="unselect" v-else></div>
            <div class="line">线路{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  props: ["showOverlay"],
  data() {
    return {
      currentApi: "", // 当前api
      apiUrls: JSON.parse(process.env.VUE_APP_BASE_HOSTS), // api数组
    };
  },
  created() {
    this.currentApi = this.apiUrls[0];
  },
  methods: {
    changeLine(item) {
      this.currentApi = item;
      this.$emit("selectLine", item);
    },
  },
};
</script>
<style scoped lang="scss">
// 选线
.selectLineOverlay {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .selectionLineBox {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    width: 280px;
    .titleBox {
      color: white;
      font-size: 15px;
      text-align: center;
      height: 38px;
      line-height: 38px;
      background: linear-gradient(
        142deg,
        #ffae61 0%,
        #ff1101 48%,
        #ff00b9 100%
      );
    }
    .lineArea {
      padding: 24px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      .lineBox {
        white-space: nowrap;
        margin: 8px 20px 8px 20px;
        display: flex;
        align-items: center;
        .unselect {
          height: 12px;
          width: 12px;
          border-radius: 50%;
          background-color: rgba(238, 238, 238, 1);
        }
        .selected {
          height: 14px;
          width: 14px;
          border-radius: 50%;
          background-color: rgba(238, 238, 238, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          .select {
            height: 10px;
            width: 10px;
            border-radius: 50%;
            background-color: rgba(221, 0, 27, 1);
          }
        }
        .line {
          font-size: 15px;
          color: #666;
          margin-left: 4px;
          flex: 1;
        }
      }
    }
  }
}
</style>
